import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { content } from './shared/routes/content-routes';
import { ContentLayoutComponent } from './shared/layout/content-layout/content-layout.component';
import { LoginComponent } from './components/auth/login/login.component';
import { ConfirmAccountComponent } from './components/auth/confirm-account/confirm-account.component';
import { VideotecaInvitationComponent } from './components/videoteca/videoteca-invitation/videoteca-invitation.component';
import { GptFormComponent } from './components/grop/gpt-form/gpt-form.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { CustomPreloadStrategy } from './shared/service/custom-preload.strategy';


const routes: Routes = [
  {
    path: '',
    redirectTo: 'auth/login',
    pathMatch: 'full'
  },
  {
    path: '',
    component: ContentLayoutComponent,
    children: content
  },
  {
    path: 'auth',
    loadChildren: () => import('./components/auth/auth.module').then(m => m.AuthModule)
  },
  {
    path: 'account/confirm/:token',
    component: ConfirmAccountComponent
  },
  {
    // ✅ NUEVA: Ruta para activación de cuenta (alias de confirm)
    path: 'account/activate/:token',
    component: ConfirmAccountComponent
  },
  {
    // ✅ TEMPORAL: Ruta sin token para pruebas
    path: 'account/confirm',
    component: ConfirmAccountComponent
  },
  {
    path: 'auth/login',
    component: LoginComponent,
  },
  {
    // ✅ NUEVA: Ruta específica para invitaciones a videoteca
  path: 'videotecas/invitations/:id',
    component: VideotecaInvitationComponent
  },
  {
    path: 'dash',
    component: DashboardComponent
  },
  { path: 'bienvenida', loadChildren: () => import('./components/bienvenida/bienvenida.module').then(m => m.BienvenidaModule) }
  
 
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'enabled',
    preloadingStrategy: CustomPreloadStrategy, // Usar estrategia personalizada
    enableTracing: false // Cambiar a true solo para debug
  })],
  exports: [RouterModule],
  providers: [CustomPreloadStrategy]
})
export class AppRoutingModule { }
